import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ConfirmBlocker } from "../../hooks/useDestructiveActionBlocker";

type Props<TArgs extends any[] = []> = {
    title?: string;
    description?: string;
    blocker: ConfirmBlocker<TArgs>;
};

export default function GaiaConfirmActionDialog<TArgs extends any[] = []>({
    title,
    description,
    blocker: { state, reset, proceed },
}: Props<TArgs>) {
    const { t } = useTranslation("app");

    return (
        <Dialog open={state === "blocked"} onClose={reset}>
            <DialogTitle>{title || t("gaiaConfirmDialog.defaultTitle")}</DialogTitle>
            <DialogContent>
                <DialogContentText>{description || t("gaiaConfirmDialog.defaultDescription")}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={reset} autoFocus>
                    {t("gaiaConfirmDialog.cancel")}
                </Button>
                <Button onClick={proceed} color="error">
                    {t("gaiaConfirmDialog.proceed")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
